<template>
  <div>
    <el-table :data="list">
      <el-table-column prop="period" label="期数"> </el-table-column>
      <el-table-column label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="day" label="天数"> </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="annualrate" label="年利率">
        <template slot-scope="scope">
          <span>{{ multiply(scope.row.annualrate, 100) }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="lockCoin" label="锁仓币种"> </el-table-column>
      <el-table-column prop="lockAmount" label="锁仓数"> </el-table-column>
      <el-table-column prop="lockAddition" label="锁仓加成">
        <template slot-scope="scope">
          <span>{{ multiply(scope.row.lockAddition, 100) }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="inviteAward" label="邀请奖励">
        <template slot-scope="scope">
          <span>{{ multiply(scope.row.inviteAward, 100) }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="nowAmount" label="用户存入数"> </el-table-column>
      <el-table-column prop="userCount" label="参与人次"> </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-view"
              @click="viewDetail(scope.row)"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="删除">
            <el-button type="danger" size="small" circle icon="el-icon-delete" @click="removeItem(scope.row)"></el-button>
        </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';
import math from 'common/math';

export default {
  name: 'pledgeList',
  computed: {
    ...mapState('pledgeInterest', ['totalCount', 'pagination']),
    ...mapGetters('pledgeInterest', ['list'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapActions('pledgeInterest', ['remove']),
    ...mapMutations('pledgeInterest', ['setDetail']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    viewDetail(item) {
      this.setDetail(item);
    },
    multiply(a, b) {
      return math.multiply(a, b);
    },
    removeItem(row) {
      this.$confirm('确认要删除么？', '提示', {
        type: 'warning'
      }).then(() => {
        this.remove(row.id).then(() => {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.$emit('refresh', { page: 1 });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
